import { Box } from '@mui/material';
import React from 'react';

/**
 * Componente de leyenda configurable para mapas
 * @param {string} variant - Tipo de leyenda: 'left' o 'right'
 * @param {Array} customItems - Items personalizados (opcional)
 */
const LegendMap = ({ variant = 'left', customItems = null }) => {
  // Definir los items según el variant
  const leftItems = [
    { color: '#FFFF00', label: 'Low' },
    { color: '#FF8C00', label: 'Medium' },
    { color: '#E5322D', label: 'High' },
  ];

  const rightItems = [
    { color: '#FFFF00', label: 'Low (> 0 lightnings)' },
    { color: '#FF8C00', label: 'Medium (> 50 lightnings)' },
    { color: '#E5322D', label: 'High (> 500 lightnings)' },
  ];

  // Seleccionar los items según el variant o usar customItems
  const items = customItems || (variant === 'left' ? leftItems : rightItems);

  return (
    <Box
      role="group"
      aria-label="Legend"
      // CAMBIO CLAVE: Usamos 'sx' en lugar de 'style'
      sx={{
        position: 'absolute',
        // Ajustamos estos valores para que "bajen"
        bottom: {
          xs: '40px',   // Estaba muy arriba, con 55px queda justo sobre el botón
          lg: '35px',  // Sigue al botón cuando este sube en pantallas grandes
          xl: '40px'
        },
        right: '30px',  // Lo alineamos mejor al borde derecho junto al botón
        background: '#ffffff',
        border: '1px solid rgba(0,0,0,.12)',
        boxShadow: '0 6px 16px rgba(0,0,0,.12)',
        borderRadius: '10px',
        padding: '6px 8px',
        zIndex: 1000,
        pointerEvents: 'none',
      }}
    >
      <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {items.map((item) => (
          <li
            key={item.label}
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: 4,
              fontSize: '0.68rem',
              color: '#0B1220',
              lineHeight: 1,
            }}
          >
            <span
              style={{
                display: 'inline-block',
                width: 8,
                height: 8,
                borderRadius: 2,
                marginRight: 6,
                background: item.color,
                border: '1px solid rgba(0,0,0,.45)',
                boxShadow: 'inset 0 0 0 1px rgba(255,255,255,.35)',
                flex: '0 0 auto',
              }}
            />
            <span>{item.label}</span>
          </li>
        ))}
      </ul>
    </Box>
  );
};

export default LegendMap;